/**
 * Profile utility functions for fetching user profile data
 */

import logger from './logger';

/**
 * Fetch display name for a user, with fallback to cached value
 * 
 * Attempts to get the display name from the server via getProfileInfo.
 * If that fails, falls back to the cached displayName from the local user store.
 * Returns empty string if cached displayName equals userId (SDK fallback behavior).
 * 
 * @param {Object} client - Matrix client instance
 * @param {string} userId - Matrix user ID (e.g., @user:example.com)
 * @returns {Promise<string>} The display name or empty string
 */
export async function fetchDisplayName(client, userId) {
  if (!client || !userId) {
    return '';
  }

  try {
    const profile = await client.getProfileInfo(userId);
    return profile?.displayname || '';
  } catch (err) {
    logger.debug('[profileUtils] getProfileInfo failed, using fallback:', err.message);
    const cachedName = client?.getUser(userId)?.displayName;
    return (cachedName && cachedName !== userId) ? cachedName : '';
  }
}
